export default "__VITE_ASSET__770de3ff__"